<template>
  <div class="dropdown-container">
    <input
      :value="value_"
      class="form-control"
      type="text"
      readonly
      @click.prevent="expanded = !expanded"
      @keydown.enter.prevent = "onKeyEnter"
      @keydown.down.prevent = "onKeyDown"
      @keydown.up.prevent = "onKeyUp"
    >

    <ul ref="dropdown" :class="[ 'dropdown-menu', expanded && 'open' ]">
      <li
        v-for="(item, index) in items"
        :class="{ 'active': isActive(index) }"
        :key="index"
        :ref = "`li-${ index }`"
        @click.prevent="onClickListItem(index)"
        @mousemove="setActive(index)"
      >
        {{ textField ? item[textField] : item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'n-custom-select',

  props: {
    value: {
      type: [ Number, String ],
      default: ''
    },

    items: {
      type: Array,
      default: () => [],
      required: true
    },

    valueField: {
      type: String,
      default: ''
    },

    textField: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    current: 0,
    expanded:  false,
    local_value:  ''
  }),

  computed: {
    valueIndex () {
      if (!this.value) {
        return -1;
      }

      return this.items.findIndex(item => (
        this.valueField ? item[this.valueField] === this.value : item === this.value
      ));
    },

    value_ () {
      return this.valueIndex >= 0
        ? (this.textField ? this.items[this.valueIndex][this.textField] : this.items[this.valueIndex])
        : '';
    }
  },

  methods: {
    onClickListItem(index) {
      this.local_value = this.items[index];
      this.current = 0;
      this.expanded = false;
    },

    onKeyDown() {
      if(this.current < this.items.length - 1) {
        this.current++;
      }
      this.setScrollPosition();
    },

    onKeyUp() {
      if(this.current > 0) {
        this.current--;
      }
      this.setScrollPosition(false);
    },

    onKeyEnter() {
      this.local_value = this.items[this.current];
      this.current = 0;
      this.expanded = false;
    },

    isActive(index) {
      return index === this.current;
    },

    setActive(index) {
      this.current = index;
    },

    setScrollPosition(downward = true) {
      const li_object = this.$refs[`li-${ this.current }`][0];
      const offsetTop = li_object ? li_object.offsetTop : 0;
      const scrollTop = this.$refs['dropdown'].scrollTop;

      if (offsetTop >= 270 && downward) {
        this.$refs['dropdown'].scrollTop = offsetTop - 240;
      }

      if (scrollTop > offsetTop && !downward) {
        this.$refs['dropdown'].scrollTop = offsetTop;
      }
    }
  },

  watch: {
    local_value() {
      if (this.valueField) {
        this.$emit('input', this.local_value[this.valueField]);
      } else {
        this.$emit('input', this.local_value);
      }
    },

    expanded() {
      this.current = this.valueIndex > 0
        ? this.valueIndex
        : 0;
    }
  }
};
</script>

<style lang="scss" scope>
.dropdown-container {
  position: relative;
  padding: 0;

  input {
    cursor: default;
    max-width: 100%;
    width: 100% !important;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 1px !important;
    padding-right: 20px !important;
  }
}

.dropdown-menu {
  background-color: white;
  display: none;
  list-style: none;
  margin: 0px;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 999;

  li {
    color: #0d57a6;
    font-size: 1.125rem;
    padding: 4px;
  }

  .active {
    background-color: #1e90ff;
    color: white;
  }

  &.open {
    display: block;
    border: 1px solid #7b9dd4;
  }

  &::-webkit-scrollbar{
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    margin-top: 1px;
    background-color: #eaeaea;
    border-right: 1px solid #7b9dd4;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    margin: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/n-custom-select.vue